var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"text-center"},[_c('v-card-title',[_vm._v(_vm._s(_vm.title))]),(_vm.load)?_c('v-card-text',[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"blue","indeterminate":""}})],1):_c('v-card-text',[_c('h3',{staticClass:"mt-2"},[_vm._v("No hay convocatoria habilitada para "+_vm._s(_vm.process)+".")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }